import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CoreModule } from '../../core/core.module';
import { SelectPackageComponent } from './select-package/select-package.component';
import { OrderComponent } from './order/order.component';
import { SelectPackageModule } from '../../shared/components/select-package/select-package.module';

const routes: Routes = [
  { path: '', component: SelectPackageComponent},
  { path: 'order', component: OrderComponent }
];


@NgModule({
  declarations: [SelectPackageComponent,OrderComponent],
  imports: [
    CoreModule,
    RouterModule.forChild(routes),
    SelectPackageModule
  ]
})
export class BuyLikesModule { }
